module.exports = "<div class=\"ui star rating\"></div>"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/company-rating/company-rating.component.html
// module id = ../../../../../src/app/_components/company-rating/company-rating.component.html
// module chunks = main